export default __webpack_public_path__ + "static/media/recycle-granules.0de92dad.jpg";